import { IRecruiterDashboardMetrics } from '../../../../../hooks/useRecruiterDashboardMetrics';
import { IRecruiterDashboardSettings } from '../../../../../hooks/useRecruiterDashboardSettings';
import {
  METRIC_HIGHER_IS_BETTER,
  SHOW_RATE_BREAKPOINTS,
} from '../../../constants';
import { IDateBounds, IModalLabels, IShowRateDetailsData } from '../../types';
import { getThresholdStatus, IThresholdStatus } from '../getThresholdStatus';

export interface IShowRateModalData {
  showRateDetailsData: IShowRateDetailsData | null;
  showRateStatus: IThresholdStatus;
}

export function buildShowRateModalData(
  metrics: IRecruiterDashboardMetrics | null,
  settings: IRecruiterDashboardSettings | null,
  dateBounds: IDateBounds,
  labels: IModalLabels
): IShowRateModalData {
  const breakpoints =
    settings?.donorShowRateBreakpoints ?? SHOW_RATE_BREAKPOINTS;
  const breakpointLabels = settings?.donorShowRateLabels ?? {
    low: labels.statusPoor,
    mid: labels.statusOk,
    high: labels.statusGood,
  };

  const showRateStatus = getThresholdStatus(
    metrics?.showRate ?? 0,
    breakpoints,
    breakpointLabels,
    METRIC_HIGHER_IS_BETTER.showRate
  );

  return {
    showRateStatus,
    showRateDetailsData: metrics
      ? {
          periodLabel: labels.currentPeriod,
          periodStart: dateBounds.start,
          periodEnd: dateBounds.end,
          showRate: metrics.showRate,
          donorsWhoDonated: metrics.donorsWhoDonated,
          expectedDonations: metrics.expectedDonations,
          statusLabel: showRateStatus.label,
          statusColor: showRateStatus.color,
          breakpoints,
        }
      : null,
  };
}
